import { render, staticRenderFns } from "./mien.vue?vue&type=template&id=0be3a2e0&scoped=true&"
import script from "./mien.vue?vue&type=script&lang=js&"
export * from "./mien.vue?vue&type=script&lang=js&"
import style0 from "./mien.vue?vue&type=style&index=0&id=0be3a2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be3a2e0",
  null
  
)

export default component.exports